"use strict";
// ─── Enums ───────────────────────────────────────────────────────────────────
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.motionTokens = exports.designTokens = exports.DEVICE_STALE_AFTER_SECONDS = exports.HEALTH_CONSENT_VERSION = exports.AD_IMAGE_MAX_BYTES = exports.AD_MAX_PUBLISHED = exports.PlatformRole = exports.TEAM_COUNT_OPTIONS = exports.TEAM_PRESETS = exports.SPOTLIGHT_TIMING = exports.ScreenStatus = exports.ClassInstanceStatus = exports.BookingStatus = exports.SessionStatus = exports.HrZone = exports.ScoringMode = exports.Role = void 0;
exports.rosterDisplayName = rosterDisplayName;
exports.currencyDigits = currencyDigits;
exports.formatMoney = formatMoney;
exports.toMinor = toMinor;
exports.computeTimerPhase = computeTimerPhase;
exports.deviceStatusHint = deviceStatusHint;
var Role;
(function (Role) {
    Role["ATHLETE"] = "ATHLETE";
    Role["COACH"] = "COACH";
    Role["ADMIN"] = "ADMIN";
    Role["SUPER_ADMIN"] = "SUPER_ADMIN";
})(Role || (exports.Role = Role = {}));
var ScoringMode;
(function (ScoringMode) {
    ScoringMode["CALORIES_ONLY"] = "CALORIES_ONLY";
    ScoringMode["HR_ZONE_POINTS"] = "HR_ZONE_POINTS";
    ScoringMode["EFFORT_SCORE"] = "EFFORT_SCORE";
})(ScoringMode || (exports.ScoringMode = ScoringMode = {}));
var HrZone;
(function (HrZone) {
    HrZone["ZONE_1"] = "ZONE_1";
    HrZone["ZONE_2"] = "ZONE_2";
    HrZone["ZONE_3"] = "ZONE_3";
    HrZone["ZONE_4"] = "ZONE_4";
    HrZone["ZONE_5"] = "ZONE_5";
})(HrZone || (exports.HrZone = HrZone = {}));
var SessionStatus;
(function (SessionStatus) {
    SessionStatus["PRESTART"] = "PRESTART";
    SessionStatus["LIVE"] = "LIVE";
    SessionStatus["PAUSED"] = "PAUSED";
    SessionStatus["ENDED"] = "ENDED";
})(SessionStatus || (exports.SessionStatus = SessionStatus = {}));
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["BOOKED"] = "BOOKED";
    BookingStatus["WAITLISTED"] = "WAITLISTED";
    BookingStatus["CANCELLED"] = "CANCELLED";
    BookingStatus["ATTENDED"] = "ATTENDED";
    BookingStatus["NO_SHOW"] = "NO_SHOW";
})(BookingStatus || (exports.BookingStatus = BookingStatus = {}));
var ClassInstanceStatus;
(function (ClassInstanceStatus) {
    ClassInstanceStatus["SCHEDULED"] = "SCHEDULED";
    ClassInstanceStatus["LIVE"] = "LIVE";
    ClassInstanceStatus["COMPLETED"] = "COMPLETED";
    ClassInstanceStatus["CANCELLED"] = "CANCELLED";
})(ClassInstanceStatus || (exports.ClassInstanceStatus = ClassInstanceStatus = {}));
var ScreenStatus;
(function (ScreenStatus) {
    ScreenStatus["UNPAIRED"] = "UNPAIRED";
    ScreenStatus["PAIRED"] = "PAIRED";
    ScreenStatus["ONLINE"] = "ONLINE";
    ScreenStatus["OFFLINE"] = "OFFLINE";
})(ScreenStatus || (exports.ScreenStatus = ScreenStatus = {}));
/** Display name for a roster entry from either source (DB row with a nested
 *  athlete, or a live Redis entry with athleteName). */
function rosterDisplayName(entry) {
    if (entry.athleteName)
        return entry.athleteName;
    if (entry.athlete)
        return `${entry.athlete.firstName} ${entry.athlete.lastName}`.trim();
    return entry.athleteId;
}
/** Spotlight pacing, shared so clients can explain it. */
exports.SPOTLIGHT_TIMING = {
    /** Minimum time on stage before an event can take it. */
    minHoldMs: 6_000,
    /** A coach pick holds the stage at least this long. */
    coachHoldMs: 12_000,
    /** With nothing happening, rotate through the top three this often. */
    rotateMs: 20_000,
};
// ─── Team battle ─────────────────────────────────────────────────────────────
/** Fixed team identities so TV, dashboard and phones always agree. Index
 *  = the 0-based team number stored on SessionRoster.team. */
exports.TEAM_PRESETS = [
    { name: "Red", color: "#FF453A" },
    { name: "Blue", color: "#0A84FF" },
    { name: "Green", color: "#30D158" },
];
exports.TEAM_COUNT_OPTIONS = [2, 3];
var PlatformRole;
(function (PlatformRole) {
    PlatformRole["PLATFORM_ADMIN"] = "PLATFORM_ADMIN";
})(PlatformRole || (exports.PlatformRole = PlatformRole = {}));
/** Most published ads a gym can have at once (keeps the TV rotation short). */
exports.AD_MAX_PUBLISHED = 10;
exports.AD_IMAGE_MAX_BYTES = 2 * 1024 * 1024;
/** Currencies with 3 minor digits (fils etc.); everything else uses 2. */
const THREE_DIGIT_CURRENCIES = ["JOD", "KWD", "BHD", "OMR", "TND", "LYD", "IQD"];
function currencyDigits(currency) {
    return THREE_DIGIT_CURRENCIES.includes(currency) ? 3 : 2;
}
/** Minor units → "25.000 JOD". */
function formatMoney(minor, currency) {
    const digits = currencyDigits(currency);
    const major = (minor / 10 ** digits).toLocaleString("en-US", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
    return `${major} ${currency}`;
}
/** "25.5" (major units) → minor units. */
function toMinor(major, currency) {
    return Math.round(Number(major) * 10 ** currencyDigits(currency));
}
// ─── Privacy ──────────────────────────────────────────────────────────────────
/** Bump when the consent text materially changes; members re-consent. */
exports.HEALTH_CONSENT_VERSION = "2026-10";
/**
 * Where an interval timer is at `now` (same clock as `startedAt`). The last
 * round has no rest after it. Pure, so TV, web and tests agree.
 */
function computeTimerPhase(t, now) {
    const work = t.workSeconds * 1000;
    const rest = t.restSeconds * 1000;
    const cycle = work + rest;
    const totalMs = t.rounds * work + (t.rounds - 1) * rest;
    const elapsed = Math.max(0, now - t.startedAt);
    if (elapsed >= totalMs) {
        return { phase: "done", round: t.rounds, rounds: t.rounds, remainingMs: 0, phaseMs: 0, totalMs };
    }
    const roundIdx = Math.floor(elapsed / cycle);
    const into = elapsed - roundIdx * cycle;
    return into < work
        ? { phase: "work", round: roundIdx + 1, rounds: t.rounds, remainingMs: work - into, phaseMs: work, totalMs }
        : { phase: "rest", round: roundIdx + 1, rounds: t.rounds, remainingMs: cycle - into, phaseMs: rest, totalMs };
}
// ─── Live device status (coach view) ─────────────────────────────────────────
//
// Answers the most common mid-class question — "why isn't my heart rate on
// the board?" — for every booked athlete at once. The API returns facts
// (status, source, freshness); clients render the fix-it hint via
// deviceStatusHint() so web and mobile always say the same thing.
/** Seconds without a sample before an athlete counts as stale. Matches the
 *  leaderboard's hrStale threshold (15s), so the panel and the TV agree. */
exports.DEVICE_STALE_AFTER_SECONDS = 15;
/** Coach-facing one-line fix for an athlete's status. null when nothing
 *  needs doing. Wording assumes the coach is talking to the athlete. */
function deviceStatusHint(status, source) {
    switch (status) {
        case "LIVE":
            return null;
        case "NOT_CHECKED_IN":
            return "Booked but not checked in — ask them to scan the QR code on the TV.";
        case "NO_DATA":
            return "Checked in, no heart rate yet — open Agaru on their phone and pick a tracker (or start their watch workout).";
        case "STALE":
            switch (source) {
                case "ble_strap":
                    return "Strap signal lost — check it's on, moistened, and close to their phone.";
                case "apple_watch":
                case "wear_os":
                    return "Watch stopped sending — open Agaru on the watch and make sure the workout is running.";
                case "apple_health":
                    return "Apple Health sync delayed — open the watch's own app (e.g. Huawei Health) on their phone.";
                case "android_health":
                    return "Health Connect sync delayed — open the watch's own app on their phone.";
                case "phone_imu":
                    return "Phone stopped sending — open Agaru and keep the phone on them.";
                default:
                    return "No recent data — reopen Agaru on their phone.";
            }
    }
}
// ─── Design tokens (all channels) ─────────────────────────────────────────────
exports.designTokens = __importStar(require("./tokens.config"));
exports.motionTokens = __importStar(require("./tokens/motion"));
// ─── Per-gym features ────────────────────────────────────────────────────────
__exportStar(require("./features"), exports);
//# sourceMappingURL=index.js.map